import { Box } from '@lingoda/ui';
import { resolveProtocol } from '@lingoda/urls';

interface Props {
    imageUrl: string | undefined;
}

export const MobileBackgroundImageBox = ({ imageUrl }: Props) => {
    return (
        <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            zIndex={-1}
            style={{
                backgroundImage: `url(${resolveProtocol(imageUrl ?? '')})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }}
        />
    );
};
